import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TransferWithinAStationIcon(props: IconProps) {
    return <Icon {...props} iconKey={"transfer_within_a_station"}/>
}
